import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useP } from '../../i18n/useP';
import PageShell from '../../components/PageShell';
import PeopleHomePage from './PeopleHomePage';
import PeopleStory from './PeopleStory';

/* Accueil — la porte du module People (2026-09-01).

   On y choisit ce qu'on FAIT : les tuiles d'action de PeopleHomePage. Le récit
   de l'année (venu de la section Charges) n'est plus un onglet mais une VUE
   ouverte par sa tuile navy — un onglet « Résumé » à côté d'une tuile « Lire
   le résumé » disait deux fois la même chose sur le même écran. */
export default function PeopleHomeHub({ activeTenant, setPage, addToast, year, onYearChange,
                                        onGoPeople, onGoHeadcount, userName = null }) {
  const { t } = useTranslation();
  const p = useP();
  const [view, setView] = useState('home');

  /* Cette page n'affiche pas « Accueil » : la salutation EST son titre
     (décision 2026-09-01), la date lui répond à droite. */
  const hello = userName ? p('Bonjour {{name}},', { name: userName.split(/\s+/)[0] }) : p('Bonjour,');
  // (La date du jour a quitté ce coin le 2026-09-02 : elle vit dans la barre
  // supérieure, en date courte + semaine, après le statut du réel.)
  return (
    <PageShell framed title={hello}
               subtitle={p('Pilotez vos effectifs et vos coûts salariaux.')}>
      <div className="page-shell__panel">
        {view === 'home' ? (
          <PeopleHomePage embedded activeTenant={activeTenant} addToast={addToast} year={year} userName={userName}
            onAddPerson={() => onGoPeople && onGoPeople({ tab: 'people', action: 'add' })}
            onStory={() => setView('story')}
            onMove={() => onGoHeadcount && onGoHeadcount({ tab: 'moves', action: 'add' })}
            onGoMoves={() => onGoHeadcount && onGoHeadcount({ tab: 'moves' })}
            onPlan={() => setPage && setPage('hr-planning')}
            onTrajectory={() => setPage && setPage('hr-trajectory')}
            onGoContracts={() => onGoPeople && onGoPeople({ tab: 'people' })}
            onGoHeadcount={() => onGoHeadcount && onGoHeadcount(null)} />
        ) : (
          <>
            <button type="button" className="ph-back" onClick={() => setView('home')}>‹ {p('Accueil')}</button>
            <PeopleStory activeTenant={activeTenant} year={year} onYearChange={onYearChange}
                         onGo={() => setPage && setPage('hr-synthese')} />
          </>
        )}
      </div>
    </PageShell>
  );
}
